import { DescriptionBanner } from '../components/DescriptionBanner';
import { useFistOrderBannerService } from '../services/useFistOrderBannerService';

export const FistOrderBannerContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useFistOrderBannerService();

  if (service.isHide) {
    return null;
  }

  return <DescriptionBanner guidance_image_url={service.guidance_image_url} />;
};
